import { render, staticRenderFns } from "./SaleButtons.vue?vue&type=template&id=3c8bb7d2&"
import script from "./SaleButtons.vue?vue&type=script&lang=js&"
export * from "./SaleButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports